import type { Filter } from "@estelle/domain";

/**
 * What narrows a Contacts list before the user's own filter does.
 *
 * Here, once, because the list and its export both have to apply it. The
 * Vendors and Suppliers lists send their type to the repository and All
 * Contacts leaves customers out for someone who may not see them; the exports
 * sent neither, and so downloaded every contact under a list of 19 vendors.
 */

/**
 * The user's filter, narrowed to one contact type.
 *
 * The type is the standing condition ANDed in front of whatever was built,
 * never in place of it, so filtering inside Vendors survives a re-render.
 */
export function withContactType(typeId: string, filter: Filter): Filter {
  return {
    kind: "group",
    combinator: "and",
    children: [
      {
        kind: "condition",
        field: "typeIds",
        operator: "has_tag",
        value: typeId,
      },
      filter,
    ],
  };
}

/**
 * The directory's filter: customers are left out for someone who may not view
 * them, as a standing condition ANDed with their own filter.
 *
 * A courtesy on the demo build, whose fixture adapter does not know who is
 * asking — against the API the rows are never sent, and the server decides.
 */
export function withVisibleKinds(
  canViewCustomers: boolean,
  filter: Filter,
): Filter {
  if (canViewCustomers) return filter;
  return {
    kind: "group",
    combinator: "and",
    children: [
      {
        kind: "condition",
        field: "kind",
        operator: "is_any_of",
        value: ["contact"],
      },
      filter,
    ],
  };
}
